import { Button, Form, Modal, Radio, RadioChangeEvent, Typography } from "antd";
import React from "react";
import { useTranslation } from "react-i18next";
import getIsRedirection from "../../../../Utils/redirectionUtility";
import OTPInputComponent from "../../../Common/Components/OTPModal";
import PinInputComponent from "../../../Common/Components/PinInput";
import "./index.css";

interface IConsentStatusApprovalComponentProps {
  isAuthTypeSelectionModalVisible: boolean;
  onCloseAuthTypeSelectionModal: () => void;
  onAuthTypeRadioSelectionChange: (event: RadioChangeEvent) => void;
  onAuthTypeModalSubmit: (pin: string) => void;
  selectedAuthType: number;
  verifyOTPAuthType: (otp: string) => void;
  isAuthTypeOTPModalVisible: boolean;
  onCloseOTPModal: () => void;
  typeOfModal: string;
}

const ConsentStatusApprovalComponent: React.FC<
  IConsentStatusApprovalComponentProps
> = ({
  selectedAuthType,
  isAuthTypeOTPModalVisible,
  isAuthTypeSelectionModalVisible: isAuthTypeSelectionModalOpen,
  onCloseOTPModal,
  onCloseAuthTypeSelectionModal,
  typeOfModal,
  onAuthTypeRadioSelectionChange,
  onAuthTypeModalSubmit,
  verifyOTPAuthType,
}) => {
  const { t } = useTranslation();

  const [form] = Form.useForm();
  const radioSelect = (e: RadioChangeEvent) => {
    onAuthTypeRadioSelectionChange(e);
  };

  const consentStatusUpdateOtp = (value: any) => {
    onAuthTypeModalSubmit(value.pin);
  };

  const verifyOtpAuth = (otp: string) => {
    verifyOTPAuthType(otp);
  };

  const getTypeOfModal = () => {
    if (typeOfModal === "FAILED" || typeOfModal === "EXPIRED" || typeOfModal === "REJECTED") {
      return t("REJECT");
    }
    return typeOfModal === "READY" || typeOfModal === "APPROVED" ? t("APPROVE") : t(typeOfModal);
  };

  return (
    <>
      <OTPInputComponent
        isOpen={isAuthTypeOTPModalVisible}
        onCancel={onCloseOTPModal}
        onOtpSubmit={verifyOtpAuth}
        okText={getTypeOfModal()}
        title={getTypeOfModal() + " " + t("CONSENT")}
        onResend={() => consentStatusUpdateOtp({})}
      />

      <Modal
        title={getTypeOfModal() + " " + t("CONSENT")}
        className="footerRoot"
        open={isAuthTypeSelectionModalOpen}
        okText={"Confirm"}
        cancelButtonProps={{ hidden: true }}
        okButtonProps={{ hidden: true }}
        onCancel={onCloseAuthTypeSelectionModal}
        footer={null}
      >
        {!getIsRedirection() && (
          <Radio.Group
            buttonStyle="solid"
            onChange={radioSelect}
            value={selectedAuthType}
            className="radioGroup"
          >
            <Radio.Button id="radioButton" value={0}>
              {t("PIN")}
            </Radio.Button>
            <Radio.Button id="radioButton" value={1}>
              {t("OTP")}
            </Radio.Button>
          </Radio.Group>
        )}
        <Form
          form={form}
          className="form"
          name="basic"
          onFinish={consentStatusUpdateOtp}
          autoComplete="off"
          // onFieldsChange={setVuaIdAsMobileNumber}
          scrollToFirstError={true}
        >
          {selectedAuthType === 1 ? (
            <Typography.Text className="otp">
              {t("Continue for OTP based verification")}
            </Typography.Text>
          ) : (
            <PinInputComponent className="pinInput" />
          )}
          <Form.Item>
            <Button
              htmlType="submit"
              className="primaryButton"
              // loading={loading}
              id="statusApproval"
            >
              {getTypeOfModal()}
            </Button>
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ConsentStatusApprovalComponent;
